import { createAction, props } from '@ngrx/store';
import { SchoolActivityInstance } from '../../../models';
import { CreateSchoolActivityInstanceReq, SchoolActivityInstancesForPeriodReq } from '../../../services/school-activity.service';
export const GetSchoolActivityInstancesSuccessAction = createAction(
	'[SchoolActivities] Get GetSchoolActivityInstances Success',
	props<{ instances: SchoolActivityInstance[] }>()
);

export const GetSchoolActivityInstancesForFlexPeriodAction = createAction(
	'[SchoolActivities] Get GetSchoolActivityInstancesForFlexPeriod',
	props<{ req: SchoolActivityInstancesForPeriodReq }>()
);

export const GetSchoolActivityInstancesForFlexPeriodSuccessAction = createAction(
	'[SchoolActivities] Get GetSchoolActivityInstancesForFlexPeriod Success',
	props<{ instances: SchoolActivityInstance[] }>()
);

export const GetSchoolActivityInstancesForFlexPeriodFailureAction = createAction(
	'[SchoolActivities] Get GetSchoolActivityInstancesForFlexPeriod Failure',
	props<{ error: string }>()
);

export const SelectActivityInstanceAction = createAction('[SchoolActivities] Select SchoolActivityInstance', props<{ instanceId: number }>());

export const ClearSelectedActivityInstanceAction = createAction('[SchoolActivities] Clear SchoolActivityInstance');

export const UpdateSchoolActivityInstanceAction = createAction(
	'[SchoolActivities] Update SchoolActivityInstance',
	props<{ instance: SchoolActivityInstance }>()
);

export const UpdateSchoolActivityInstanceSuccessAction = createAction(
	'[SchoolActivities] Update SchoolActivityInstance Success',
	props<{ instance: SchoolActivityInstance }>()
);

export const UpdateSchoolActivityInstanceFailureAction = createAction(
	'[SchoolActivities] Update SchoolActivityInstance Failure',
	props<{ error: string }>()
);

export const RemoveSchoolActivityInstanceAction = createAction('[SchoolActivities] Remove SchoolActivityInstance', props<{ instanceId: number }>());

export const RemoveSchoolActivityInstanceSuccessAction = createAction(
	'[SchoolActivities] Remove SchoolActivityInstance Success',
	props<{ instanceId: number }>()
);

export const RemoveSchoolActivityInstanceFailureAction = createAction(
	'[SchoolActivities] Remove SchoolActivityInstance Failure',
	props<{ error: string }>()
);

export const AddSchoolActivityInstanceAction = createAction(
	'[SchoolActivities] Add SchoolActivityInstance',
	props<{ instance: SchoolActivityInstance }>()
);

export const AddSchoolActivityInstanceSuccessAction = createAction(
	'[SchoolActivities] Add SchoolActivityInstance Success',
	props<{ instance: SchoolActivityInstance }>()
);

export const AddSchoolActivityInstanceFailureAction = createAction(
	'[SchoolActivities] Add SchoolActivityInstance Failure',
	props<{ error: string }>()
);

// bulk create instances
export const CreateSchoolActivityInstancesBulkAction = createAction(
	'[SchoolActivities] Create SchoolActivityInstancesBulk',
	props<{ instanceReqs: CreateSchoolActivityInstanceReq[] }>()
);

export const CreateSchoolActivityInstancesBulkSuccessActionV2 = createAction(
	'[SchoolActivities] Create SchoolActivityInstancesBulk Success V2',
	props<{ instances: SchoolActivityInstance[] }>()
);

export const CreateSchoolActivityInstancesBulkFailureAction = createAction(
	'[SchoolActivities] Create SchoolActivityInstancesBulk Failure',
	props<{ error: string }>()
);

export const GetSchoolActivityInstancesForActivityAction = createAction(
	'[SchoolActivities] Get GetSchoolActivityInstancesForActivity',
	props<{ activityId: number }>()
);

export const GetSchoolActivityInstancesForActivitySuccessAction = createAction(
	'[SchoolActivities] Get GetSchoolActivityInstancesForActivity Success',
	props<{ activityId: number; instances: SchoolActivityInstance[] }>()
);
